var SubMenus;
(function (SubMenus) {
    myonce('submenus', () => {
        const $body = document.querySelector('body');
        const $header = document.querySelector('#header');
        if ($header) {
            const $triggers = $header.querySelectorAll('[data-has-submenu]');
            const $submenusWrappers = $header.querySelectorAll('.submenus');
            $submenusWrappers.forEach(($submenusWrapper) => {
                $submenusWrapper.style.top = $header.offsetTop + $header.offsetHeight + 'px';
                $triggers.forEach(($trigger) => {
                    const subMenuId = $trigger.getAttribute('data-has-submenu');
                    const $targetSubmenu = subMenuId && $submenusWrapper.querySelector(`[data-submenu=${subMenuId}]`);
                    if ($targetSubmenu) {
                        let timeout;
                        $trigger.addEventListener('mouseenter', () => {
                            if (!$targetSubmenu.classList.contains('active')) {
                                timeout = setTimeout(() => {
                                    $submenusWrapper.querySelectorAll('[data-submenu]').forEach(($submenu) => {
                                        $submenu.classList.remove('is-active');
                                    });
                                    const menuLevel = $submenusWrapper.id;
                                    document.querySelectorAll('.submenus').forEach(($submenus) => { if ($submenus.id != menuLevel)
                                        $submenus.classList.remove('is-active'); });
                                    $body.classList.add('scrollLock');
                                    $body.classList.remove('scrollReleaseDsk');
                                    $submenusWrapper.classList.add('is-active');
                                    $targetSubmenu.classList.add('is-active');
                                }, 500);
                            }
                        });
                        $trigger.addEventListener('mouseleave', () => {
                            clearTimeout(timeout);
                        });
                        if ($trigger.querySelector('a'))
                            $trigger.querySelector('a').addEventListener('click', function (e) {
                                clearTimeout(timeout);
                            });
                    }
                });
            });
        }
    });
})(SubMenus || (SubMenus = {}));
